import { Injectable } from '@angular/core';
import { Observable, first, of, switchMap } from 'rxjs';
import { PurchasePersistenceRepository } from '../../core/domain/purchase-persistence/repositories/purchase-persistence.repository';
import { PurchasePersistenceModel } from '@/core/domain/purchase-persistence/models/PurchasePersistence.model';
import { Store } from '@ngrx/store';
import {
    deletePurchasePersistenceAction,
    savePurchasePersistenceAction,
} from './store/purchase-persistence.actions';
import { DateTime } from 'luxon';

@Injectable({
    providedIn: 'root',
})
export class PurchasePersistenceImplRepository extends PurchasePersistenceRepository {
    constructor(
        // eslint-disable-next-line @ngrx/no-typed-global-store
        private readonly store: Store<{
            purchasePersistence: PurchasePersistenceModel;
        }>,
    ) {
        super();
    }
    override savePurchase(
        purchase: PurchasePersistenceModel,
    ): Observable<PurchasePersistenceModel> {
        return this.getPurchase().pipe(
            switchMap(
                (responsePurchasePersistence: PurchasePersistenceModel) => {
                    const purchaseToSave = JSON.parse(
                        JSON.stringify(responsePurchasePersistence),
                    );
                    purchaseToSave.expiration = DateTime.now()
                        .plus({ hour: 1 })
                        .toISO();
                    if (purchase?.amount) {
                        purchaseToSave.amount = purchase.amount;
                    }
                    if (purchase?.cardDesign) {
                        purchaseToSave.cardDesign = purchase.cardDesign;
                    }
                    if (purchase?.shipment) {
                        purchaseToSave.shipment = purchase.shipment;
                        if (purchase.shipment?.recipientScheduleShipping) {
                            if (
                                typeof purchaseToSave.shipment
                                    .recipientScheduleShipping === 'string'
                            ) {
                                purchaseToSave.shipment.recipientScheduleShipping =
                                    DateTime.fromISO(
                                        purchase.shipment
                                            ?.recipientScheduleShipping,
                                    );
                            }
                            if (
                                purchaseToSave.shipment
                                    .recipientScheduleShipping instanceof Date
                            ) {
                                purchaseToSave.shipment.recipientScheduleShipping =
                                    DateTime.fromJSDate(
                                        purchase.shipment
                                            ?.recipientScheduleShipping,
                                    );
                            }
                        }
                    }
                    if (purchase?.message) {
                        purchaseToSave.message = purchase.message;
                    }
                    this.store.dispatch(
                        savePurchasePersistenceAction({
                            value: purchaseToSave,
                        }),
                    );
                    return of(purchaseToSave);
                },
            ),
        );
    }
    override getPurchase(): Observable<PurchasePersistenceModel> {
        // eslint-disable-next-line @ngrx/prefer-selector-in-select
        return this.store.select('purchasePersistence').pipe(first());
    }
    override deletePurchase(): Observable<void> {
        this.store.dispatch(deletePurchasePersistenceAction());
        return of();
    }
}
